/**
 * 全站 UI 尺寸／顏色基準（行動優先 + 年長使用者易用性）
 *
 * 對應 CLAUDE.md「專案定位 / UIUX 設計原則」。
 * 這裡是 JS（inline style / 元件）使用的單一來源；
 * index.css 的 CSS 變數與 AntdConfig 的 theme token 皆以此為準，三者必須保持一致。
 *
 * 原則：字體寧大勿小、觸控目標夠大、次要文字顏色刻意加深以利年長者閱讀。
 */

/** 觸控目標最小邊長（px）。可點擊元素不應小於此值。 */
export const TOUCH_MIN = 44;

/** 清單列最小高度（px）：全螢幕選擇頁（MobilePicker）等整列可點的清單。 */
export const LIST_ROW_MIN = 56;

/** 勾選框／單選圓點邊長（px）。Ant 預設 16px 手指難點中。 */
export const CHECKBOX_SIZE = 22;

/** 拖曳條（Slider）尺寸（px）：handle 圓點直徑、rail 軌道粗細、touch 整條可觸控高度。 */
export const SLIDER = {
  handle: 20,
  rail: 6,
  touch: 28,
};

/**
 * 字級（px）。內文寧大勿小；
 * caption 為最小下限，僅供次要輔助文字使用，不得再更小。
 */
export const FONT = {
  caption: 13, // 最小：時間戳、輔助說明等次次要文字
  secondary: 14, // 次要資訊
  body: 16, // 內文基準
  subtitle: 18, // 區塊標題 / 重要文字
  title: 22, // 頁面主標
};

/**
 * 文字顏色。次要 / 輔助色刻意比 Ant Design 預設更深，
 * 確保年長使用者在淺底上仍有足夠對比（避免 #bfbfbf / #94a3b8 這類過淺灰）。
 */
export const TEXT = {
  primary: "#262626",
  secondary: "#595959",
  muted: "#8c8c8c",
  inverse: "#ffffff",
  /** 頁面主標／品牌標題專用深藍色（登入頁、頁首、章節標題），非內文顏色。 */
  heading: "#202951",
};

/** 主色（與 AntdConfig colorPrimary 一致）。 */
export const COLOR_PRIMARY = "#007dda";

/** 警示／危險色（與 AntdConfig colorError 一致）：錯誤狀態、破壞性操作。 */
export const COLOR_DANGER = "#f22020";

/** 常用圓角。 */
export const RADIUS = {
  sm: 8,
  md: 12,
  lg: 16,
};

/** safe-area（瀏海／底部 home bar）字串，供 inline style 直接套用。 */
export const SAFE_AREA = {
  top: "env(safe-area-inset-top, 0px)",
  bottom: "env(safe-area-inset-bottom, 0px)",
};

/**
 * 底部固定 Tab Bar 的內容高度（不含 safe-area）。
 * 頁面若有自己的「釘在畫面最底部」按鈕列（如設定頁儲存鈕），
 * 須以此值 + SAFE_AREA.bottom 墊高，避免被 Tab Bar 蓋住。
 */
export const BOTTOM_TAB_BAR_HEIGHT = 56;
